!(function () {
  "use strict";
  var t = {
      4739: function (t, e, n) {
        var i = n(4662);
        const a = new (class {
          constructor() {
            (this.items = Array.from(document.querySelectorAll(".cart-item"))),
              this.items.forEach((t) => this.manageState(t)),
              (this.selectorsToUpdate = [
                ".cart-summary__header",
                "#cart-total-price",
                "#checkout",
                ".cart-summary__free-shipping",
              ]),
              (this.mainCartSelector = ".shopify-section.cart"),
              (this.miniCartSelector = "#mini-cart"),
              (this.itemsContainersSelector =
                ".cart-items-container, .mini-cart--empty"),
              (this.parser = new DOMParser());
          }
          manageState(t) {
            const e = t.getAttribute("data-variant-id");
            t.querySelector(
              ".cart-item-delete, .cart-item__remove"
            ).addEventListener("click", async () => {
              await this.changeCartItem({ id: e, quantity: 0 }), t.remove();
            });
            const n = t.querySelector('input[name="quantity"]');
            if (!n) return;
            const i = t.querySelector('button[name="plus"]'),
              a = t.querySelector('button[name="minus"]');
            let r = parseInt(n.value);
            i.addEventListener("click", () => {
              (r += 1),
                (n.value = r),
                this.changeCartItem({ id: e, quantity: r });
            }),
              a.addEventListener("click", () => {
                (r -= 1),
                  (n.value = r),
                  this.changeCartItem({ id: e, quantity: r });
              });
          }
          async changeCartItem(t) {
            const { response: e, error: n } = await (0, i.aO)(
              `${routes.cartChange}`,
              {
                ...(0, i.Dz)(),
                body: JSON.stringify({
                  line: +t.id,
                  quantity: t.quantity,
                  sections: "main-cart,navigation-main",
                }),
              }
            );
            if (n) return void console.error(n);
            const a = await e.json(),
              r = this.parser.parseFromString(
                a.sections["main-cart"],
                "text/html"
              ),
              o = this.parser.parseFromString(
                a.sections["navigation-main"],
                "text/html"
              );
            if (0 === a.item_count) {
              document.querySelector(this.mainCartSelector) &&
                (document.querySelector(this.mainCartSelector).innerHTML =
                  r.querySelector(this.mainCartSelector).innerHTML);
              const t = document.querySelector("#mini-cart");
              return (
                t &&
                  ((t.innerHTML = o.querySelector("#mini-cart").innerHTML),
                  t.addEventListeners()),
                document
                  .querySelectorAll("#mini-cart .icon")
                  .forEach((t) => t.classList.add("loaded")),
                void this.renderElements(r)
              );
            }
            this.renderItems(r);
          }
          renderElements(t) {
            this.selectorsToUpdate.forEach((e) => {
              try {
                const n = document.querySelectorAll(e),
                  i = t.querySelector(e);
                n.length &&
                  i &&
                  n.forEach((t) => {
                    i
                      .querySelectorAll(".icon")
                      .forEach((t) => t.classList.add("loaded")),
                      t.replaceWith(i.cloneNode(!0));
                  });
              } catch (t) {
                console.error(`Error updating ${e}`, t);
              }
            });
            const e = t.querySelector(".cart-count");
            document
              .querySelectorAll(
                "#cart-open-block .header__icons--cart-open .cart-count"
              )
              .forEach((t) => {
                e
                  ? (t.classList.contains("visually-hidden") &&
                      t.classList.remove("visually-hidden"),
                    (t.textContent = e.textContent))
                  : t.classList.add("visually-hidden");
              }),
              document
                .querySelector("#cart-open-block .icon")
                .classList.add("loaded");
          }
          renderItems(t) {
            this.renderElements(t);
            const e = Array.from(
                document.querySelectorAll(this.itemsContainersSelector)
              ),
              n = t.querySelector(this.itemsContainersSelector);
            e.forEach((t) => {
              t && t.replaceWith(n.cloneNode(!0));
            }),
              document.querySelectorAll(".cart-item").forEach((t) => {
                t
                  .querySelectorAll(".icon")
                  .forEach((t) => t.classList.add("loaded")),
                  this.manageState(t);
              });
          }
        })();
        (e.A = a),
          customElements.get("cart-note") ||
            customElements.define(
              "cart-note",
              class extends HTMLElement {
                constructor() {
                  super(),
                    this.querySelector("textarea").addEventListener(
                      "change",
                      (0, i.sg)((t) => {
                        const e = JSON.stringify({ note: t.target.value });
                        fetch(`${routes.cartUpdate}`, {
                          ...(0, i.Dz)(),
                          body: e,
                        });
                      }, 300)
                    );
                }
              }
            );
      },
      1287: function (t, e, n) {
        n.d(e, {
          p: function () {
            return r;
          },
        });
        var i = n(4662),
          a = n(4739);
        const r = () => {
          const t = document.querySelectorAll('form[action="/cart/add"]'),
            e = document.getElementById("main-cart"),
            n = document.getElementById("mini-cart");
          t.length &&
            t.forEach((t) =>
              t.addEventListener("submit", (r) => {
                r.preventDefault();
                r.stopPropagation();

                const buttonSpan = r.target.querySelector(
                  'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                );
                if (buttonSpan) {
                  buttonSpan.textContent = `${cartStrings.addingToCart}`;
                }

                r.target
                  .querySelector('button[type="submit"]')
                  .classList.add("added");

                const cartIcon = r.target.querySelector(
                  'button[type="submit"] > span.cart-icon'
                );
                if (cartIcon) {
                  cartIcon.style.display = "none";
                }

                const loadingIcon = r.target.querySelector(
                  'button[type="submit"] > svg.loading-icon'
                );
                if (loadingIcon) {
                  loadingIcon.style.display = "block";
                }
                const o = (0, i.Dz)("javascript");
                (o.headers["X-Requested-With"] = "XMLHttpRequest"),
                  delete o.headers["Content-Type"];
                const s = new FormData(t);
                s.append("sections", "main-cart"),
                  (o.body = s),
                  fetch(`${routes.cartAdd}`, o)
                    .then((t) => t.json())
                    .then(async (t) => {
                      if (t.status) {
                        if (
                          ((r.target.querySelector(
                            'button[type="submit"] > span.cart-icon'
                          ).style.display = "inline-flex"),
                          (r.target.querySelector(
                            'button[type="submit"] > svg.loading-icon'
                          ).style.display = "none"),
                          r.target.querySelector(
                            'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                          ) &&
                            (r.target.querySelector(
                              'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                            ).textContent = `${cartStrings.addToCart}`),
                          "object" == typeof t.description)
                        )
                          return Object.entries(t.description).forEach((t) => {
                            let [e, n] = t;
                            const i = `${n.join(", ")}`;
                            r.target.querySelector(
                              ".main-product__error"
                            ).innerHTML =
                              '<span class="icon loaded">error</span><p>' +
                              i +
                              "</p>";
                          });
                        r.target.querySelector(
                          ".main-product__error"
                        ).innerHTML =
                          '<span class="icon loaded">error</span><p>' +
                          t.description +
                          "</p>";
                      } else {
                        if ("cart" === cartStrings.uxCart)
                          return void (window.location.href =
                            window.routes.cart);
                        (r.target.querySelector(
                          ".main-product__error"
                        ).innerHTML = ""),
                          e && e.classList.add("added"),
                          a.A.renderItems(
                            new DOMParser().parseFromString(
                              t.sections["main-cart"],
                              "text/html"
                            )
                          ),
                          "mini-cart" === cartStrings.uxCart && n && n.open(),
                          r.target.querySelector(
                            'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                          ) &&
                            (r.target.querySelector(
                              'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                            ).textContent = `${cartStrings.addedToCart}`),
                          r.target
                            .querySelector('button[type="submit"]')
                            .classList.remove("added"),
                          r.target
                            .querySelector('button[type="submit"]')
                            .classList.add("successful"),
                          (r.target.querySelector(
                            'button[type="submit"] > span.cart-icon'
                          ).style.display = "flex"),
                          (r.target.querySelector(
                            'button[type="submit"] > svg.loading-icon'
                          ).style.display = "none");
                      }
                    })
                    .catch((t) => {
                      console.error("Error:", t);
                    });
              })
            );
        };
      },
      4662: function (t, e, n) {
        n.d(e, {
          Dz: function () {
            return i;
          },
          aO: function () {
            return a;
          },
          jW: function () {
            return r;
          },
          qF: function () {
            return c;
          },
          sg: function () {
            return o;
          },
        });
        const i = function () {
            return {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: `application/${
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : "json"
                }`,
              },
            };
          },
          a = async function () {
            let t, e;
            try {
              t = await fetch(...arguments);
            } catch (t) {
              e = t;
            }
            return { response: t, error: e };
          },
          r = function () {
            let t =
              arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            const e = window.innerWidth - document.body.offsetWidth,
              n = document.getElementById("nav-wrapper");
            t
              ? (document.body.classList.add("no-scroll"),
                (document.body.style.paddingRight = e + "px"),
                (n.style.paddingRight = e + "px"))
              : (document.body.classList.remove("no-scroll"),
                (document.body.style.paddingRight = "0px"),
                (n.style.paddingRight = "0px"));
          };
        function o(t, e) {
          const n = this;
          let i;
          return function () {
            for (var a = arguments.length, r = new Array(a), o = 0; o < a; o++)
              r[o] = arguments[o];
            clearTimeout(i),
              (i = setTimeout(function () {
                return t.apply(n, r);
              }, e));
          };
        }
        document.querySelectorAll(".local-scroll").forEach((t) => {
          t.addEventListener("click", (t) => {
            t.preventDefault(), t.stopPropagation();
            const e = t.target.getAttribute("href");
            ((t) => {
              Math.easeInOutQuad = function (t, e, n, i) {
                return (t /= i / 2) < 1
                  ? (n / 2) * t * t + e
                  : (-n / 2) * (--t * (t - 2) - 1) + e;
              };
              const e = document.getElementById("grid-archive-header"),
                n = document.getElementById("nav-wrapper");
              let i = 0,
                a = 0;
              e && (i = e.offsetHeight + 50), n && (a = n.offsetHeight + 50);
              const r = t.offsetTop - i - a,
                o = window.scrollY,
                s = r - o;
              let c = 0;
              const l = () => {
                c += 5;
                const t = Math.easeInOutQuad(c, o, s, 200);
                window.scrollTo(0, t), c < 200 && setTimeout(l, 5);
              };
              l();
            })(document.querySelector(e));
          });
        });
        const s = {};
        function c(t) {
          document.removeEventListener("focusin", s.focusin),
            document.removeEventListener("focusout", s.focusout),
            document.removeEventListener("keydown", s.keydown),
            t && t.focus();
        }
      },
    },
    e = {};
  function n(i) {
    var a = e[i];
    if (void 0 !== a) return a.exports;
    var r = (e[i] = { exports: {} });
    return t[i](r, r.exports, n), r.exports;
  }
  (n.d = function (t, e) {
    for (var i in e)
      n.o(e, i) &&
        !n.o(t, i) &&
        Object.defineProperty(t, i, { enumerable: !0, get: e[i] });
  }),
    (n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (function () {
      var t = n(4662),
        e = n(1287);
      document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(".icon").forEach((t) => {
          t.classList.add("loaded");
        }),
          document.querySelectorAll('a[target="_blank"]').forEach((t) => {
            t.innerHTML =
              t.innerHTML +
              '<span class="visually-hidden"> ' +
              accessibilityNoticeNewTab +
              "</span>";
          }),
          (0, e.p)();
      }),
        void 0 !== window.BOOMR &&
          console.log(
            "Built with " +
              window.BOOMR.themeName +
              " (https://themes.shopify.com/themes/align/) version " +
              window.BOOMR.themeVersion +
              " by Company XYZ (https://companyxyz.io/)."
          ),
        void 0 === window.Shopify && (window.Shopify = {}),
        (Shopify.bind = function (t, e) {
          return function () {
            return t.apply(e, arguments);
          };
        }),
        (Shopify.setSelectorByValue = function (t, e) {
          for (var n = 0, i = t.options.length; n < i; n++) {
            var a = t.options[n];
            if (e == a.value || e == a.innerHTML)
              return (t.selectedIndex = n), n;
          }
        }),
        (Shopify.addListener = function (t, e, n) {
          t.addEventListener
            ? t.addEventListener(e, n, !1)
            : t.attachEvent("on" + e, n);
        }),
        (Shopify.postLink = function (t, e) {
          var n = (e = e || {}).method || "post",
            i = e.parameters || {},
            a = document.createElement("form");
          for (var r in (a.setAttribute("method", n),
          a.setAttribute("action", t),
          i)) {
            var o = document.createElement("input");
            o.setAttribute("type", "hidden"),
              o.setAttribute("name", r),
              o.setAttribute("value", i[r]),
              a.appendChild(o);
          }
          document.body.appendChild(a),
            a.submit(),
            document.body.removeChild(a);
        }),
        (Shopify.CountryProvinceSelector = function (t, e, n) {
          (this.countryEl = document.getElementById(t)),
            (this.provinceEl = document.getElementById(e)),
            (this.provinceContainer = document.getElementById(
              n.hideElement || e
            )),
            Shopify.addListener(
              this.countryEl,
              "change",
              Shopify.bind(this.countryHandler, this)
            ),
            this.initCountry(),
            this.initProvince();
        }),
        (Shopify.CountryProvinceSelector.prototype = {
          initCountry: function () {
            var t = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, t),
              this.countryHandler();
          },
          initProvince: function () {
            var t = this.provinceEl.getAttribute("data-default");
            t &&
              this.provinceEl.options.length > 0 &&
              Shopify.setSelectorByValue(this.provinceEl, t);
          },
          countryHandler: function (t) {
            var e = (a =
                this.countryEl.options[
                  this.countryEl.selectedIndex
                ]).getAttribute("data-provinces"),
              n = JSON.parse(e);
            if ((this.clearOptions(this.provinceEl), n && 0 == n.length))
              this.provinceContainer.style.display = "none";
            else {
              for (var i = 0; i < n.length; i++) {
                var a;
                ((a = document.createElement("option")).value = n[i][0]),
                  (a.innerHTML = n[i][1]),
                  this.provinceEl.appendChild(a);
              }
              this.provinceContainer.style.display = "";
            }
          },
          clearOptions: function (t) {
            for (; t.firstChild; ) t.removeChild(t.firstChild);
          },
          setOptions: function (t, e) {
            var n = 0;
            for (e.length; n < e.length; n++) {
              var i = document.createElement("option");
              (i.value = e[n]), (i.innerHTML = e[n]), t.appendChild(i);
            }
          },
        });
      const i = () => {
        var t = [].slice.call(document.querySelectorAll("img"));
        if (
          "IntersectionObserver" in window &&
          "IntersectionObserverEntry" in window &&
          "intersectionRatio" in window.IntersectionObserverEntry.prototype
        ) {
          let e = new IntersectionObserver(function (t, e) {
            t.forEach(function (t) {
              if (t.isIntersecting) {
                let n = t.target;
                n.classList.contains("loaded") ||
                  (n.classList.add("loaded"), e.unobserve(n));
              }
            });
          });
          t.forEach(function (t) {
            e.observe(t);
          });
        }
      };
      i(),
        document.querySelectorAll("video").forEach((t) => {
          t.muted = !0;
          let e = t.play();
          void 0 !== e &&
            e.then((e) => {
              new IntersectionObserver(
                (e) => {
                  e.forEach((e) => {
                    e.isIntersecting
                      ? 1 == t.autoplay && t.paused && t.play()
                      : t.paused || t.pause();
                  });
                },
                { threshold: 0 }
              ).observe(t);
            });
        });
      const a = function () {
        [].slice.call(document.querySelectorAll("video")).forEach((t) => {
          const e = t.parentElement.querySelector(".figure--video__poster");
          e &&
            e.addEventListener("click", () => {
              e.classList.add("hidden"), t.play();
            });
        });
        var t = [].slice.call(
          document.querySelectorAll(".figure--video-external")
        );
        if ("IntersectionObserver" in window) {
          var e = new IntersectionObserver(function (t, e) {
            t.forEach(function (t) {
              if (t.isIntersecting)
                "vimeo" == t.target.dataset.type &&
                  fetch(
                    "http://vimeo.com/api/v2/video/" +
                      t.target.dataset.id +
                      ".json"
                  )
                    .then((t) => {
                      if (!t.ok) throw new Error(`HTTP error ${t.status}`);
                      return t.json();
                    })
                    .then((e) => {
                      t.target.querySelector(
                        ".figure--video__external-poster-image"
                      ).src = e[0].thumbnail_large;
                    }),
                  t.target.addEventListener("click", function () {
                    if (!t.target.querySelector("iframe")) {
                      let t = this.dataset.type,
                        e = document.createElement("iframe");
                      e.setAttribute("frameborder", "0"),
                        e.setAttribute("allowfullscreen", ""),
                        e.setAttribute("allow", "autoplay"),
                        "youtube" == t
                          ? (e.setAttribute("id", "youtube"),
                            e.setAttribute(
                              "src",
                              "https://www.youtube.com/embed/" +
                                this.dataset.id +
                                this.dataset.videotags +
                                "rel=0&showinfo=0&autoplay=1"
                            ))
                          : e.setAttribute(
                              "src",
                              "https://player.vimeo.com/video/" +
                                this.dataset.id +
                                this.dataset.videotags +
                                "rel=0&showinfo=0&autoplay=1"
                            ),
                        this.appendChild(e),
                        setTimeout(() => {
                          this.querySelector(
                            ".figure--video__poster"
                          ).classList.add("hidden");
                        }, 350);
                    }
                  });
              else if (t.target.querySelector("iframe")) {
                let n = t.target.dataset.type,
                  i = t.target.querySelectorAll("iframe");
                if ("youtube" == n) {
                  var e = { event: "command", func: "pauseVideo" };
                  i[0].contentWindow.postMessage(JSON.stringify(e), "*");
                } else
                  "vimeo" == n &&
                    ((e = { method: "pause", value: "true" }),
                    i[0].contentWindow.postMessage(JSON.stringify(e), "*"));
              }
            });
          });
          t.forEach(function (t) {
            e.observe(t);
          });
        }
      };
      a(),
        window.addEventListener("beforeprint", () => {
          const t = document.body.querySelectorAll("details"),
            e = document.body.querySelectorAll("img");
          for (let e = 0; e < t.length; e++)
            t[e].open
              ? (t[e].dataset.open = "1")
              : t[e].setAttribute("open", "");
          for (let t = 0; t < e.length; t++) e[t].dataset.open = "1";
        }),
        window.addEventListener("afterprint", () => {
          const t = document.body.querySelectorAll("details");
          for (let e = 0; e < t.length; e++)
            t[e].dataset.open
              ? (t[e].dataset.open = "")
              : t[e].removeAttribute("open");
        }),
        Shopify.designMode &&
          document.addEventListener("shopify:section:load", () => {
            a(),
              document.querySelectorAll(".icon").forEach((t) => {
                t.classList.add("loaded");
              }),
              document.querySelectorAll("img").forEach((t) => {
                t.classList.add("loaded");
              });
          });
      class r extends HTMLElement {
        constructor() {
          super(), this.addEventListener("change", this.onVariantChange);
        }
        onVariantChange() {
          this.updateOptions(),
            this.updateMasterId(),
            this.updateVariantStatuses(),
            this.updateImageSwatches(),
            this.currentVariant
              ? (this.updateMedia(),
                this.updateURL(),
                this.renderProductInfo(),
                this.updateVariantInput(),
                this.toggleStockStatus(this.currentVariant.available))
              : this.setUnavailable();
        }
        updateOptions() {
          this.options = Array.from(
            this.querySelectorAll("select, fieldset"),
            (t) =>
              "SELECT" === t.tagName
                ? t.value
                : "FIELDSET" === t.tagName
                ? Array.from(t.querySelectorAll("input")).find((t) => t.checked)
                    ?.value
                : void 0
          );
        }
        updateMasterId() {
          this.currentVariant = this.getVariantData().find(
            (t) => !t.options.map((t, e) => this.options[e] === t).includes(!1)
          );
        }
        updateVariantStatuses() {
          const t = this.querySelector(":checked").value,
            e = this.getVariantData().filter((e) => e.options[0] === t);
          this.getProductVariantSelects().forEach((t) => {
            const n = t.querySelectorAll("select, fieldset");
            n.forEach((t, i) => {
              if (0 === i) return;
              const a = t.querySelectorAll('input[type="radio"], option'),
                r = n[i - 1].querySelector(":checked").value,
                o = e
                  .filter((t) => t.available && t[`option${i}`] === r)
                  .map((t) => t[`option${i + 1}`]);
              this.setInputAvailability(a, o);
            });
          });
        }
        setInputAvailability(t, e) {
          t.forEach((t) => {
            const n = t.getAttribute("value"),
              i = e.includes(n);
            (t.disabled = !i),
              "OPTION" === t.tagName &&
                (t.innerText = i
                  ? n
                  : window.productStrings.unavailable_with_option.replace(
                      "[value]",
                      n
                    ));
          });
        }
        updateImageSwatches() {
          this.querySelectorAll("fieldset:has(.image-swatch)").forEach((t) => {
            const e = t.dataset.optionPosition,
              n = t.querySelectorAll(".image-swatch");
            for (const t of n) {
              const n = [...this.options];
              n[e - 1] = t.value;
              const i = this.getVariantData().find(
                (t) =>
                  t.options[0] == n[0] &&
                  t.options[1] == n[1] &&
                  t.options[2] == n[2]
              );
              if (!i) continue;
              const a = t.labels[0],
                r = a.querySelectorAll("img.variant-image"),
                o = a.querySelector(`img[data-variant-id="${i.id}"]`),
                s = a.querySelector(".image_swatch--text_value");
              r.forEach((t) => {
                t.classList.add("u-hide");
              }),
                s.classList.add("u-hide"),
                o ? o.classList.remove("u-hide") : s.classList.remove("u-hide");
            }
          });
        }
        updateMedia() {
          if (!this.currentVariant) return;
          if (!this.currentVariant.featured_media) return;
          const t = document.querySelector(
            `.main-product__gallery#gallery-${this.dataset.section}`
          );
          if (this.currentVariant.featured_media) {
            const e = this.currentVariant.featured_media.id;
            if (t.swiper) {
              const n = t.swiper.slides;
              for (const i of n)
                if (!i.classList.contains("swiper-slide-duplicate")) {
                  const n = i.dataset.id,
                    a = i.dataset.swiperSlideIndex;
                  if (e == n) {
                    t.swiper.slideToLoop(a);
                    break;
                  }
                }
            } else {
              const t = document.querySelector(
                  `.main-product__gallery#gallery-${this.dataset.section} .swiper-wrapper`
                ),
                n = t.querySelector(`[data-id="${e}"]`);
              n && t.prepend(n);
            }
            const n = document.querySelectorAll(".sticky-add-to-cart__image"),
              i = this.currentVariant.id;
            n.forEach((t) => {
              t.dataset.variantId == i
                ? t.classList.remove("u-hide")
                : t.classList.add("u-hide");
            });
          }
        }
        updateURL() {
          if (!this.currentVariant || "false" === this.dataset.updateUrl)
            return;
          const t = `${this.dataset.url}?variant=${this.currentVariant.id}`;
          window.history.replaceState({}, "", t);
        }
        updateVariantInput() {
          document
            .querySelectorAll(
              `#form-product-${this.dataset.section}, #form-product-installment-${this.dataset.section}`
            )
            .forEach((t) => {
              const e = t.querySelector('input[name="id"]');
              (e.value = this.currentVariant.id),
                e.dispatchEvent(new Event("change", { bubbles: !0 }));
            });
          const t = this.getProductVariantSelects();
          t.length > 1 && this.syncSelectValues(t);
        }
        syncSelectValues(t) {
          t.forEach((t) => {
            t.querySelectorAll("select, fieldset").forEach((t) => {
              if ("SELECT" === t.tagName)
                this.currentVariant.options[t.dataset.optionPosition - 1] &&
                  (t.value =
                    this.currentVariant.options[t.dataset.optionPosition - 1]);
              else if ("FIELDSET" === t.tagName) {
                const e = Array.from(t.querySelectorAll("input")).find(
                  (e) =>
                    e.value ===
                    this.currentVariant.options[t.dataset.optionPosition - 1]
                );
                e && (e.checked = !0);
              }
            });
          });
        }
        renderProductInfo() {
          fetch(
            `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
          )
            .then((t) => t.text())
            .then((e) => {
              const n = new DOMParser().parseFromString(e, "text/html"),
                a = document.getElementById(`price-${this.dataset.section}`),
                r = n.getElementById(`price-${this.dataset.section}`),
                o = document.getElementById(
                  `sticky-price-${this.dataset.section}`
                ),
                s = n.getElementById(`sticky-price-${this.dataset.section}`),
                c = document.getElementById(
                  `pickup-availability-${this.dataset.section}`
                ),
                l = n.getElementById(
                  `pickup-availability-${this.dataset.section}`
                ),
                d = document.getElementById(
                  `pickup-availability-modal-${this.dataset.section}`
                ),
                u = n.getElementById(
                  `pickup-availability-modal-${this.dataset.section}`
                );
              r && a
                ? (a.classList.remove("u-invisible"),
                  (a.innerHTML = r.innerHTML),
                  (a.classList = r.classList))
                : a.classList.add("u-invisible"),
                s && o
                  ? (o.classList.remove("u-invisible"),
                    (o.innerHTML = s.innerHTML),
                    (o.classList = s.classList))
                  : o && o.classList.add("u-invisible"),
                l && c && (c.innerHTML = l.innerHTML),
                u && d && (d.innerHTML = u.innerHTML);
              const h = document.querySelector(".pickup-availability"),
                p = document.getElementById("overlay"),
                m = document.getElementById("pickup-availability-open"),
                y = document.getElementById("pickup-availability-close");
              m &&
                document
                  .getElementById("pickup-availability-open")
                  .addEventListener("click", function () {
                    h.classList.add("open"),
                      p.classList.add("open"),
                      document.body.classList.add("active", "minicart"),
                      (0, t.jW)(!0),
                      i();
                  }),
                y &&
                  document
                    .getElementById("pickup-availability-close")
                    .addEventListener("click", function () {
                      h.classList.remove("open"),
                        document.body.classList.remove("active", "minicart"),
                        (0, t.jW)(!1),
                        overlay.classList.remove("open", "overlay--all"),
                        (0, t.qF)(h);
                    });
            });
        }
        toggleStockStatus(t) {
          const e = document.querySelectorAll(
              `.form-product-${this.dataset.section}`
            ),
            n = document.getElementById(`stock-status-${this.dataset.section}`);
          e &&
            (t
              ? (e.forEach((t) => {
                  const e = t.querySelector('[name="add"]'),
                    n = t.querySelector('[name="add"] > span:not(.cart-icon)');
                  e &&
                    (e.removeAttribute("disabled"),
                    (n.textContent = `${cartStrings.addToCart}`));
                }),
                n && (n.dataset.state = "in-stock"))
              : (e.forEach((t) => {
                  const e = t.querySelector('[name="add"]'),
                    n = t.querySelector('[name="add"] > span:not(.cart-icon)');
                  e &&
                    (e.setAttribute("disabled", "disabled"),
                    (n.textContent = `${cartStrings.soldOut}`));
                }),
                n && (n.dataset.state = "out-of-stock")));
        }
        setUnavailable() {
          const t = document.querySelectorAll(
              `.form-product-${this.dataset.section}`
            ),
            e = document.getElementById(`stock-status-${this.dataset.section}`);
          t.forEach((t) => {
            const n = t.querySelector('[name="add"]'),
              i = t.querySelector('[name="add"] > span:not(.cart-icon)');
            n &&
              ((i.textContent = `${cartStrings.unavailable}`),
              n.setAttribute("disabled", "disabled"),
              e && (e.dataset.state = "unavailable"));
          });
          const n = document.getElementById(`price-${this.dataset.section}`),
            i = document.getElementById(`sticky-price-${this.dataset.section}`);
          n && this.setPriceUnavailable(n), i && this.setPriceUnavailable(i);
        }
        setPriceUnavailable(t) {
          t.classList.remove("price--on-sale"),
            t.classList.add("price--sold-out"),
            (t.querySelector(
              ".price__regular .price-item.price-item--regular"
            ).textContent = window.productStrings.price_unavailable);
        }
        getVariantData() {
          return (
            (this.variantData =
              this.variantData ||
              JSON.parse(
                this.querySelector('[type="application/json"]').textContent
              )),
            this.variantData
          );
        }
        getProductVariantSelects() {
          return document.querySelectorAll(
            `variant-selects[data-section=${this.dataset.section}]`
          );
        }
      }
      customElements.define("variant-selects", r);
      class o {
        constructor(t) {
          (this.el = t),
            (this.summary = t.querySelector("summary")),
            (this.content = t.querySelector(".content")),
            (this.animation = null),
            (this.isClosing = !1),
            (this.isExpanding = !1),
            this.summary.addEventListener("click", (t) => this.onClick(t));
        }
        onClick(t) {
          t.preventDefault(),
            (this.el.style.overflow = "hidden"),
            this.isClosing || !this.el.open
              ? this.open()
              : (this.isExpanding || this.el.open) && this.shrink();
        }
        shrink() {
          this.isClosing = !0;
          const t = `${this.el.offsetHeight}px`,
            e = `${this.summary.offsetHeight}px`;
          this.animation && this.animation.cancel(),
            (this.animation = this.el.animate(
              { height: [t, e] },
              { duration: 400, easing: "ease-out" }
            )),
            (this.animation.onfinish = () => this.onAnimationFinish(!1)),
            (this.animation.oncancel = () => (this.isClosing = !1));
        }
        open() {
          (this.el.style.height = `${this.el.offsetHeight}px`),
            (this.el.open = !0),
            window.requestAnimationFrame(() => this.expand());
        }
        expand() {
          this.isExpanding = !0;
          const t = `${this.el.offsetHeight}px`,
            e = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
          this.animation && this.animation.cancel(),
            (this.animation = this.el.animate(
              { height: [t, e] },
              { duration: 400, easing: "ease-out" }
            )),
            (this.animation.onfinish = () => this.onAnimationFinish(!0)),
            (this.animation.oncancel = () => (this.isExpanding = !1));
        }
        onAnimationFinish(t) {
          (this.el.open = t),
            (this.animation = null),
            (this.isClosing = !1),
            (this.isExpanding = !1),
            (this.el.style.height = this.el.style.overflow = "");
        }
      }
      document.querySelectorAll("details.accordion__wrapper").forEach((t) => {
        new o(t);
      });
    })();
})();
